import { getCompassDirection, type CombatPosition } from '@hexcrawl/shared-utils';
import type { FacingDirection } from '@/utils/AnimatedSprite';
import Tilemap = Phaser.Tilemaps.Tilemap;

// I hate the existence of these magic numbers, but I've banged my head against this problem for too long. They seem
// to fix the minor discrepency with the existing data, so I'm leaving it as is for now.
const X_CORRECTION = 16;
const Y_CORRECTION = 12;

// The primary reason for this class is how unreliable tilemap's worldToTileXY and tileToWorldXY is. They really should
// work, but in practice they're always way off from how Tiled renders the exact same data. I'd really like the game
// renderer and the tool to be in sync, thus I've written my own class to translate coordiante to make them line up.
// Thanks Phaser.
export class CombatCoordinates {
  constructor(private readonly tilemap: Tilemap) {
    this.tilemap = tilemap;
  }

  worldToTile(worldX: number, worldY: number, floor: boolean = false): CombatPosition {
    // const coords = this.tilemap.worldToTileXY(worldX, worldY);
    // const x = coords?.x ?? 0;
    // const y = coords?.y ?? 0;

    const tileWidthHalf = this.tilemap.tileWidth / 2;
    const tileHeightHalf = this.tilemap.tileHeight / 2;

    const tileset = this.tilemap.getTileset("battlefield-tiles");
    if (!tileset) throw new Error("CombatCoordinates not available");
    worldX = worldX - this.tilemap.tileWidth - tileset.tileOffset.x - X_CORRECTION;
    worldY = worldY + tileset.tileOffset.y - Y_CORRECTION;

    const x = 0.5 * (worldX / tileWidthHalf + worldY / tileHeightHalf);
    const y = 0.5 * (-worldX / tileWidthHalf + worldY / tileHeightHalf);

    if (floor) {
      return { x: Math.floor(x), y: Math.floor(y) };
    }

    return { x, y };
  }

  tileToWorld(tileX: number, tileY: number): CombatPosition {
    // const coords = this.tilemap.tileToWorldXY(tileX, tileY);
    // const x = coords?.x ?? 0;
    // const y = coords?.y ?? 0;

    const tileWidthHalf = this.tilemap.tileWidth / 2;
    const tileHeightHalf = this.tilemap.tileHeight / 2;

    let x = (tileX - tileY) * tileWidthHalf;
    let y = (tileX + tileY) * tileHeightHalf;

    const tileset = this.tilemap.getTileset("battlefield-tiles");
    if (!tileset) throw new Error("CombatCoordinates not available");
    x = x + this.tilemap.tileWidth + tileset.tileOffset.x - X_CORRECTION;
    y = y - tileset.tileOffset.y + Y_CORRECTION;

    return { x, y };
  }

  getFacingBetweenPositions(from: CombatPosition, to: CombatPosition): FacingDirection {
    const fromWorld = this.tileToWorld(from.x + 0.5, from.y + 0.5);
    const toWorld = this.tileToWorld(to.x + 0.5, to.y + 0.5);
    return getCompassDirection(toWorld.x - fromWorld.x, toWorld.y - fromWorld.y) ?? 'south';
  }
}
